import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider, createGlobalStyle } from 'styled-components';
import blankSkin from './blank';
import defaultSkin from './default';

import defaultCSS from '../default.css';
import blankCSS from '../blank.css';

const skinCSS = {
  default: defaultCSS,
  blank: blankCSS
};

const SkinContext = createContext({
  currentSkin: 'blank',
  setSkin: () => {},
  availableSkins: ['blank', 'default']
});

export const useSkin = () => useContext(SkinContext);

const skins = {
  blank: blankSkin,
  default: defaultSkin
};

export const ThemeProvider = ({ children, initialSkin = 'blank' }) => {
  const [currentSkin, setCurrentSkin] = useState(initialSkin);

  const GlobalStyle = createGlobalStyle`${skinCSS[currentSkin]}`;

  const setSkin = (skinName) => {
    if (!skins[skinName]) {
      console.error(`Skin "${skinName}" not found`);
      return;
    }

    setCurrentSkin(skinName);
    localStorage.setItem('preferredSkin', skinName);
  };

  useEffect(() => {
    const savedSkin = localStorage.getItem('preferredSkin') || initialSkin;
    setCurrentSkin(savedSkin);
  }, [initialSkin]);

  return (
    <SkinContext.Provider
      value={{
        currentSkin,
        setSkin,
        availableSkins: Object.keys(skins)
      }}
    >
      <StyledThemeProvider theme={skins[currentSkin]}>
        <GlobalStyle />
        {children}
      </StyledThemeProvider>
    </SkinContext.Provider>
  );
};

export default ThemeProvider;
